import subprogramNbaSchoolTeamSumaryStore from '@modules/subprogram/nba/subprogram-nba-school-team-page-summary-store';
import { i18n } from '@shared/i18n';

const tabsConfig = {
  summary: {
    disabled: false,
    type: 'summary',
    label: i18n('entities.subprogram.nba.tabs.summary'),
    routerPush: {
      params: {
        tabName: 'summary'
      }
    },
  },
  players: {
    disabled: false,
    type: 'players',
    label: i18n('entities.subprogram.nba.tabs.players'),
    routerPush: {
      params: {
        tabName: 'players'
      }
    },
  },
  parents: {
    disabled: false,
    type: 'parents',
    label: i18n('entities.subprogram.nba.tabs.parents'),
    routerPush: {
      params: {
        tabName: 'parents'
      }
    },
  },
};
export default {
  namespaced: true,

  modules: {
    summary: subprogramNbaSchoolTeamSumaryStore,
  },

  state: {
    tabIndex: 0,
    tabs: [],
    subpropertyId: null,
    programId: null,
    subprogramId: null,
    subprogram: null,
    program: null,
    loading: false,
  },

  getters: {
    tabs: (state) => state.tabs,
    tabIndex: (state) => state.tabIndex,
    subpropertyId: (state) => state.subpropertyId,
    programId: (state) => state.programId,
    subprogramId: (state) => state.subprogramId,
    subprogram: (state) => state.subprogram,
    program: (state) => state.program,
    loading: (state) => state.loading,
  },

  mutations: {
    SET_TABS(state, payload) {
      state.tabs = payload;
    },
    SET_TAB_INDEX(state, payload) {
      state.tabIndex = payload;
    },
    INIT_PARAMS(state, {
      subpropertyId,
      programId,
      subprogramId
    }) {
      state.subpropertyId = subpropertyId;
      state.programId = programId;
      state.subprogramId = subprogramId;
    },
    LOAD_STARTED(state) {
      state.loading = true;
      state.program = null;
      state.subprogram = null;
    },
    LOAD_SUCCESS(
      state,
      {
        program,
        subprogram,
      },
    ) {
      state.loading = false;
      state.program = program;
      state.subprogram = subprogram;
    },
    LOAD_ERROR(state) {
      state.loading = false;
      state.program = null;
      state.subprogram = null;
    },
  },

  actions: {
    doSetTabs({ commit }) {
      const tabs = Object.values(tabsConfig);
      commit('SET_TABS', tabs);
    },
    doResetTabs({ commit }) {
      commit('SET_TAB_INDEX', 0);
    },
    setTabIndex({ commit }, tabIndex) {
      commit('SET_TAB_INDEX', tabIndex);
    },
  },
};